/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { getToken } from '~services/utils'; // eslint-disable-line

// Messages
import messages from './messages/ChatForm_messages';

import Button from '../../components/Button';
import { Form, Input } from '../../components/Form';

const propTypes = {
  id: PropTypes.number,
  saveChat: PropTypes.func,
  onMessageSend: PropTypes.func,
};

class ChatForm extends PureComponent {
  state = {
    message: '',
  };

  handleMessageChange = e => {
    this.setState({ message: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();

    const message = this.state.message.trim();
    if (!message) return;

    const token = getToken();

    this.props.saveChat({
      chatId: this.props.id,
      token,
      message,
      is_client: !!token,
      sent_at: new Date()
        .toISOString()
        .slice(0, 19)
        .replace('T', ' '),
    });

    this.setState({ message: '' });
    this.props.onMessageSend();
  };

  render() {
    return (
      <FormContainer onSubmit={this.handleSubmit}>
        <MessageInput
          onChange={this.handleMessageChange}
          placeholder="Kirjoita viestisi tähän."
          type="text"
          value={this.state.message}
        />
        <SendButton type="submit">
          <FormattedMessage {...messages.chatFormSendButton} />
        </SendButton>
      </FormContainer>
    );
  }
}

ChatForm.propTypes = propTypes;

const FormContainer = styled(Form)`
  display: flex;
  width: 100%;
`;

const MessageInput = styled(Input)`
  flex: 1;
`;

const SendButton = styled(Button)`
  margin-left: 12px;
`;

export default ChatForm;
